import { useEffect, useState } from "react";
import { Link, useRouterState } from "@tanstack/react-router";
import { ArrowLeft, X } from "lucide-react";
import { SANCTUARY_RETURN_KEY } from "@/lib/sanctuary";

/** Shows "Return to the Sanctuary" on tools opened from the Healing Sanctuary. */
export function ReturnToSanctuary() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const [active, setActive] = useState(false);

  useEffect(() => {
    try {
      setActive(sessionStorage.getItem(SANCTUARY_RETURN_KEY) === "1");
    } catch {
      setActive(false);
    }
  }, [pathname]);

  if (!active || pathname.startsWith("/sanctuary")) return null;

  const clear = () => {
    try { sessionStorage.removeItem(SANCTUARY_RETURN_KEY); } catch { /* ignore */ }
    setActive(false);
  };

  return (
    <div className="sanct-return" role="region" aria-label="Healing Sanctuary">
      <Link to="/sanctuary" className="sanct-return__link">
        <ArrowLeft className="size-4" aria-hidden /> Return to the Sanctuary
      </Link>
      <button type="button" onClick={clear} className="sanct-return__close" aria-label="Hide this reminder">
        <X className="size-4" aria-hidden />
      </button>
    </div>
  );
}
